import Pako from "pako";
import SaveFormat from "../common/save/SaveFormat";
import { FileInfoOneDrive } from "../features/editor/EditorState";
import { getToken } from "../common/authMicrosoft";
import { IPublicClientApplication } from "@azure/msal-browser";

const BASE_URL = "https://graph.microsoft.com/v1.0";

export const fetchSaveProject = async (
	instance: IPublicClientApplication,
	saveFormat: SaveFormat,
	driveId: string,
	itemId: string,
	update: boolean,
	newName: string | null,
): Promise<FileInfoOneDrive> => {
	const json = JSON.stringify(saveFormat);
	const compressed = Pako.deflate(json) as any;

	const authToken = await getToken(instance, {
		command: "authenticate",
		resource: "",
		type: "Upload",
	});

	const file = new Blob([compressed], { type: "blob" });

	const filename = newName ? newName : saveFormat.editor.projectName;

	const url = update
		? `${BASE_URL}/drives/${driveId}/items/${itemId}/content`
		: `${BASE_URL}/drives/${driveId}/items/${itemId}:/${filename}.ppf:/content`;

	const response = await fetch(url, {
		method: "PUT",
		headers: {
			Authorization: `Bearer ${authToken}`,
			"Content-Type": "blob",
		},
		body: file,
	});

	if (response.status > 300) {
		throw Error("Error saving project to One Drive");
	}

	const fileInfo: FileInfoOneDrive = await response.json();

	return fileInfo;
};

export const fetchUpdateProjectName = async (
	name: string,
	instance: IPublicClientApplication,
	driveId: string,
	fileId: string,
): Promise<FileInfoOneDrive> => {
	const authToken = await getToken(instance, {
		command: "authenticate",
		resource: "",
		type: "Upload",
	});

	const url = `${BASE_URL}/drives/${driveId}/items/${fileId}`;

	const response = await fetch(url, {
		method: "PATCH",
		headers: {
			Authorization: `Bearer ${authToken}`,
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			name: `${name}.ppf`,
		}),
	});

	if (response.status > 300) {
		throw Error("Error updating project name to One Drive");
	}

	const fileInfo = await response.json();

	return fileInfo;
};
